'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$45() {
  this.bDe = null;
  this.bDf = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$45 as $c_Lpresto_TwoFactorAuthView$$anon$45 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$45.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$45;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$45() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$45 as $h_Lpresto_TwoFactorAuthView$$anon$45 };
$h_Lpresto_TwoFactorAuthView$$anon$45.prototype = $p;
$p.P = (function() {
  if ((!this.bDf)) {
    this.bDe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bDf = true;
  }
  return this.bDe;
});
var $d_Lpresto_TwoFactorAuthView$$anon$45 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$45, "presto.TwoFactorAuthView$$anon$45", ({
  T4: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$45 as $d_Lpresto_TwoFactorAuthView$$anon$45 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$45.js.map
